<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  async mounted() {
    const url = window.location.href.split('#')[0]
    const params = {
      url
    }

    const res = await axios.post('https://ar.lanxiongtiyu.com/ar_api/v1/wx/getTicketSign.do', qs.stringify(params))
    window.wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: 'wx4690a55401737a1f', // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名z 的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: [
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
      ] // 必填，需要使用的JS接口列表
    })


    window.wx.ready(() => {
      // const _url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=https://ar.lanxiongtiyu.com/ar_api/v1/wx/opLogin.do?redirectUrl=${window.location.origin}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      // const link = `${window.location.origin}/redirect?redirectUrl=${_url}`
      const timeLineConf = {
        title: '2019健身教练最佳发展平台评选', // 分享标题
        imgUrl: 'http://imgcdn.lanxiongsports.com/upload/shape/share.jpg', // 分享图标
        success() {
        }
      }

      const friendsConf = {
        title: '2019健身教练最佳发展平台评选', // 分享标题
        // desc: this.activityDetail.lecturerInfo.intro, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://imgcdn.lanxiongsports.com/upload/shape/share.jpg', // 分享图标
        desc: '欢迎参加“2019健身教练最佳发展平台”榜单评选活动。',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success() {
        }
      }
      window.wx.onMenuShareTimeline(timeLineConf)
      window.wx.onMenuShareAppMessage(friendsConf)
    })


  }
}
</script>

<style lang="scss">
html,
body {
  background: url("http://imgcdn.lanxiongsports.com/upload/shape/bg3.jpg")
    repeat;
  width: 100vw;
  overflow-x: hidden;
}
#app {
  max-width: 990px;
  margin: 0 auto;
  width: 100vw;
  overflow-x: hidden;
}
@media (max-width: 1024px) {
  ::-webkit-scrollbar {
    display: none !important;
  }
}
</style>
